// This icon file is generated automatically.
var PCheckCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M9.92 4.52H9.2a.5.5 0 00-.4.2L6.32 8.13 5.22 6.59a.5.5 0 00-.4-.21h-.74c-.1 0-.16.11-.1.2l1.94 2.7c.2.27.61.27.81 0l3.3-4.57c.05-.08 0-.2-.1-.2z" } }, { "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }] }] }, "name": "p-check-circle", "theme": "outlined" };
export default PCheckCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCheckCircleOutlined.js
// module id = 3281
// module chunks = 0